<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Editar Terminal de Venda
        </span>
      </h3>
    </div>
    <Form url="/terminalVenda/update" :terminal="terminal" :is-update="true" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import TerminalData from "./TerminalData";

export default {
  name: "app-terminal-update",
  data() {
    return {
      terminal: new TerminalData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getTerminal(uuid_terminal) {
      const { data } = await this.$http.post("/terminalVenda/find", {
        uuid_terminal,
      });
      return data;
    },
    async getInit() {
      try {
        const uuid_terminal = this.$route.params.uuid_terminal;

        this.setLoading(true);
        const terminal = await this.getTerminal(uuid_terminal);
        this.setLoading(false);

        if (!terminal || !terminal.uuid_terminal) {
          this.$router.push({ name: "terminais" });
          return this.$toast.error("Terminal não encontrado!");
        }

        this.terminal = new TerminalData(terminal);
      } catch {
        this.setLoading(false);
      }
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
      return;
    }
    this.getInit();
  },
};
</script>
